import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import { useMatch } from '@reach/router';
import { loadData } from '@jelly/utils';
export var UserActivityContext = /*#__PURE__*/React.createContext();

/**
 * This is the User Activity Provider context component
 * We're able to set the user logged in status here so throughout the app we can access this information
 */
export function UserActivityProvider(_ref) {
  var _ref$activity = _ref.activity,
      results = _ref$activity.results,
      search = _ref$activity.search,
      children = _ref.children,
      path = _ref.path,
      userId = _ref.userId;

  var _useState = useState(results),
      _useState2 = _slicedToArray(_useState, 2),
      activityResults = _useState2[0],
      setActivityResults = _useState2[1];

  var _useState3 = useState(search),
      _useState4 = _slicedToArray(_useState3, 2),
      activitySearch = _useState4[0],
      setActivitySearch = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var match = useMatch("".concat(path, ":page"));
  var page = match && match.page || 1;
  var isFirstRender = useRef(true);
  useEffect(function () {
    if (!isFirstRender.current) {
      setIsLoading(true);
      loadData("/api/activity-by-user-id/".concat(userId, "/").concat(page, "/")).then(function (_ref2) {
        var results = _ref2.results,
            search = _ref2.search;
        setActivityResults(results);
        setActivitySearch(search);
        setIsLoading(false);
      });
    }

    isFirstRender.current = false;
  }, [userId, page]);
  return /*#__PURE__*/React.createElement(UserActivityContext.Provider, {
    value: {
      isLoading: isLoading,
      activityResults: activityResults,
      activitySearch: activitySearch
    }
  }, children);
}